import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const localStorageAuthToken = localStorage.getItem('token');

export const apiSlice = createApi({
  reducerPath: 'api',
  //baseQuery: fetchBaseQuery({ baseUrl: 'http://127.0.0.1:8000' }),
  baseQuery: fetchBaseQuery({ baseUrl: 'https://api.globaladvanceddata.com' }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: 'login',
        method: 'POST',
        body: credentials,
      }),
    }),
    register: builder.mutation({
      query: (credentials) => ({
        url: 'users',
        method: 'POST',
        body: credentials,
      }),
    }),
    fetchPermissions: builder.query({
      query: (token) => ({
        url: 'permissions',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    whoami: builder.query({
      query: (token) => ({
        url: 'whoami',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getallusers: builder.query({
      query: ({ skip = 0, limit = 10 }) => ({
        url: `users_with_plans?skip=${skip}&limit=${limit}`,
        headers: {
          Authorization: `Bearer ${localStorageAuthToken}`,
        },
      }),
    }),
    payments: builder.query({
      query: ({ token, userId }) => ({
        url: 'users/' + userId + '/payment-plans/',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
    }),
    createPayment: builder.mutation({
      query: ({ token, payment }) => ({
        url: 'payment-plans/',
        method: 'POST',
        body: payment,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    })
  }),
});

export const { useLoginMutation, useFetchPermissionsQuery, useWhoamiQuery,useGetallusersQuery, usePaymentsQuery, useCreatePaymentMutation, useRegisterMutation } = apiSlice;
